<template>
  <!-- create/update planning modal -->
  <div class="table-crud-modal" ref="updateModal" style="width: 950px;">
    <h2 class="lvl2-heading">Editer planning</h2>
    <el-form
      v-if="!selectedVideo"
      :model="params"
      label-position="left"
      :status-icon="true"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="pharmacist_id">
            <span>Pharmacien*:</span>
            <el-select
              no-data-text="..."
              v-model="params.pharmacist_id"
              placeholder="Pharmacien"
              filterable
              disabled
            >
              <el-option
                v-for="pharma in pharmacists"
                :key="`pharma__f-${pharma.id}`"
                :label="pharma.full_name"
                :value="pharma.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item prop="support_id">
            <span>Support*:</span>
            <el-select
              no-data-text="..."
              popper-class="supports-f"
              v-model="params.support_id"
              placeholder="Supports"
              filterable
            >
              <template v-if="pharmacistSupports.length">
                <el-option
                  v-for="sup in pharmacistSupports"
                  :key="`sup__f-${sup.id}`"
                  :label="sup.name"
                  :value="sup.id"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <!-- <el-col :span="12">
          <el-form-item prop="request">
            <span>Demande:</span>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="params.request"
              placeholder="Demande"
            ></el-input>
          </el-form-item>
        </el-col> -->

        <el-col :span="12">
          <el-form-item prop="status">
            <span>Status:</span>
            <el-select
              class="v-list-videos__filter-item"
              v-model="params.status"
              placeholder="Status"
            >
              <el-option
                v-for="stat in statuses"
                :key="`status__${stat.value}`"
                :label="stat.label"
                :value="stat.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item>
            <span>Groupement:</span>
            <Checkbox
              label="Planning défini par groupement?"
              name="use_group"
              @change="params.use_group = +$event"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="display_competitor_price">
            <span>Prix concurrent:</span>
            <Checkbox
              label="Afficher prix concurrent?"
              name="display_competitor_price"
              @change="params.display_competitor_price = +$event"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="price">
            <span>Prix de vente:</span>
            <el-input-number
              v-model="params.price"
              :min="0"
              :controls="false"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="scheduled_at">
            <span>Date:</span>
            <el-date-picker
              v-model="params.scheduled_at"
              :type="
                modal.payload.planning.mode === 'weekly' ? 'week' : 'month'
              "
              :picker-options="pickerOptions"
              format="yyyy-WW"
              placeholder="Date de planning"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item>
            <span>Vidéos:</span>
            <el-select
              no-data-text="..."
              v-model="tempVideos"
              filterable
              multiple
              remote
              reserve-keyword
              :multiple-limit="10"
              :remote-method="remoteVideos"
              :loading="loading"
            >
              <el-option
                v-for="video in computedVideos"
                :key="video.id"
                :label="video.title"
                :value="video.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-table
        v-if="videosRequest"
        :data="videosWithRequest"
        style="width: 100%"
      >
        <el-table-column label="Video" prop="video.media" width="200">
        </el-table-column>
        <el-table-column
          label="Demande"
          prop="planningVideo.request"
          width="250"
        >
          <template slot-scope="{ row }">
            <base-button
              :style="{ width: '100%' }"
              :fluid="false"
              @click.prevent.stop.native="
                seeRequest(buttonText(row) === 'Voir la demande' ? row : null)
              "
              :type="buttonType(row)"
              >{{ buttonText(row) }}</base-button
            >
          </template>
        </el-table-column>
        <el-table-column label="Etat" prop="planningVideo.request_status">
          <template slot-scope="{ row }">
            <span v-if="row.planningVideo.request_status == 0">En attente</span>
            <span v-else-if="row.planningVideo.request_status == 1"
              >Acceptée</span
            >
            <span v-else-if="row.planningVideo.request_status == 2"
              >Refusée</span
            >
            <span v-else-if="row.planningVideo.request_status == 3"
              >Terminée</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="Action"
          prop="planningVideo.request_status"
          width="140"
        >
          <template slot-scope="{ row }">
            <base-button
              :fluid="false"
              @click.prevent.stop.native="sendRequest(row, 1, $event)"
              v-if="row.planningVideo.request_status == 0"
              >Accepter</base-button
            >
          </template>
        </el-table-column>
        <el-table-column width="140" v-if="request_status == 0">
          <template slot-scope="{ row }">
            <base-button
              :fluid="false"
              @click.prevent.stop.native="sendRequest(row, 2, $event)"
              v-if="row.planningVideo.request_status == 0"
              >Refuser</base-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-form-item style="text-align: right">
        <base-button
          @click.prevent.stop.native="handleSubmit"
          :fluid="false"
          :disabled="isDisabled"
          >Editer</base-button
        >
      </el-form-item>
    </el-form>
    <div v-if="selectedVideo" class="table__request">
      <base-button class="table__request--return" @click.native="hideRequest"
        >Cacher la demande</base-button
      >
      <el-col :span="24">
        <!-- <request-table
          v-if="selectedVideo"
          ref="request-table"
          :is-content="selectedVideo.request"
        /> -->
        <div
          v-if="selectedVideo"
          v-html="
            selectedVideo.request
              ? decodeURIComponent(selectedVideo.request)
              : 'Aucune requête'
          "
          class="table__request--body"
        />
        <MultiCarousel
          v-if="getFiles.length"
          class="table__request--carousel"
          @change="setSelectedFile($event)"
        >
          <div
            class="table__request--item"
            v-for="item in getFiles"
            :key="item.id"
          >
            <img
              v-if="fileTypes.images.includes(item.extension)"
              :src="item.file"
              :alt="item.name"
            />
            <TheVideoPlayer
              v-else-if="fileTypes.videos.includes(item.extension)"
              :media_url="item.file"
              imageUrl=""
            />
            <base-link
              :path="item.file"
              :blank="true"
              v-if="fileTypes.pdf.includes(item.extension)"
            >
              {{ item.name }}
            </base-link>
          </div>
        </MultiCarousel>
      </el-col>
    </div>
    <base-button
      v-if="selectedVideo && selectedVideo.files"
      :fluid="false"
      class="download-btn"
      @click.prevent.stop.native="downloadFile()"
      type="hollowed"
      >Télécharger</base-button
    >
  </div>
</template>

<script>
import {
  Message,
  InputNumber,
  Form,
  FormItem,
  Row,
  Col,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn
} from "element-ui"
import { emitter } from "@/utils"
import Checkbox from "@/components/Checkbox_Improved"
import { mapState, mapGetters } from "vuex"
import { updatePlanning, updateVodRequest } from "@/api/plannings"
import { fetchUsers } from "@/api/users"
import { getUserSupport } from "@/api/supports"
import { getVideos as fetchVideos, fetchVideo } from "@/api/videos"
import { downloadRequestFile } from "@/api/plannings"
import { loaderMixin } from "@/mixins"
import TheVideoPlayer from "@/components/TheVideoPlayer"
import MultiCarousel from "@/components/MultiCarousel"
import BaseLink from "@/components/BaseLink"

export default {
  components: {
    ElInputNumber: InputNumber,
    Checkbox,
    ElForm: Form,
    ElFormItem: FormItem,
    ElRow: Row,
    ElCol: Col,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
    ElTable: Table,
    ElTableColumn: TableColumn,
    MultiCarousel,
    TheVideoPlayer,
    BaseLink
  },
  mixins: [loaderMixin],
  computed: {
    ...mapState(["supports"]),
    ...mapGetters(["modal"]),
    computedVideos() {
      return this.Videos
    },
    getFiles() {
      return this.selectedVideo.files
        ? this.selectedVideo.files.map(({ path, name }, id) => {
            const splittedFile = path.split(".")
            const extension = splittedFile[splittedFile.length - 1]
            return {
              id,
              file: path,
              name,
              extension
            }
          })
        : []
    }
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1
      },
      params: {
        support_id: 1,
        status: "pending",
        use_group: 0,
        display_competitor_price: 0,
        scheduled_at: new Date(),
        price: 0,
        request: "",
        pharmacist_id: null,
        videos: [],
      },
      fileTypes: {
        images: [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "jpe",
          "jfif",
          "svg",
          "tif",
          "tiff",
          "cmx",
          "ico",
          "pnm",
          "pbm",
          "pgm",
          "ppm"
        ],
        videos: [
          "mp4",
          "mov",
          "mp2",
          "mpa",
          "mpe",
          "mpeg",
          "mpg",
          "mpv2",
          "qt",
          "lsf",
          "lsx",
          "asf",
          "asr",
          "asx",
          "avi",
          "movie"
        ],
        pdf: ["pdf"]
      },
      statuses: [
        { label: "En attente", value: "pending" },
        { label: "Révision", value: "pending_review" },
        { label: "Validation", value: "approved" }
      ],
      pharmacistSupports: [],
      pharmacists: [],
      tempVideos: [],
      Videos: [],
      freeVideos: [],
      loading: false,
      videosRequest: false,
      videosWithRequest: [],
      request_status: 0,
      selectedVideo: null,
      isDisabled: false,
      currentFile: 0
    }
  },
  methods: {
    hideRequest() {
      setTimeout(() => {
        this.selectedVideo = null
      }, 20)
    },
    buttonText(row) {
      return this.selectedVideo && this.selectedVideo.video_id === row.video.id
        ? "Cacher la demande"
        : "Voir la demande"
    },
    buttonType(row) {
      return this.selectedVideo && this.selectedVideo.video_id === row.video.id
        ? "hollowed"
        : "filled"
    },
    seeRequest(row) {
      if (row) {
        this.selectedVideo = null
        setTimeout(() => {
          const { request, video_id, files } = row.planningVideo
          if (!this.selectedVideo || this.selectedVideo.video_id !== video_id) {
            this.selectedVideo = { request, video_id, files }
          } else {
            this.selectedVideo = null
          }
        }, 20)
      } else {
        this.selectedVideo = null
      }
    },
    async getPharmacistSupports() {
      let { data } = await getUserSupport(this.params.pharmacist_id)
      this.pharmacistSupports = data
    },
    handleSubmit() {
      this.openLoader(this.$refs.updateModal)

      this.params.videos = this.tempVideos
      // updating the planning
      updatePlanning(this.modal.payload.planning.id, this.params)
        .then(() => {
          emitter.$emit("update-table")
          Message.success("Planning edité")
          this.$store.dispatch("closeModal")
          this.closeLoader()
        })
        .catch(() => {
          /* if (err.reponse && err.reponse.error && err.response.error.message) {
            Message.error(err.response)
          } else {
            Message.error("Planning n'a pas été edité")
          } */
          this.closeLoader()
        })
    },
    handleDateChange(val) {
      // NOTICE
      // need to check if planning already exists
      this.params.scheduled_at = val.toDateString()
    },
    remoteVideos(query) {
      this.loading = true
      fetchVideos({
        keyword: query,
        paginate: 0,
        support_id: this.params.support_id
      }).then(videos => {
        this.loading = false

        this.Videos = videos
      })
    },
    sendRequest(planning, stat, event) {
      this.openLoader(this.$refs.updateModal)
      this.isDisabled = true
      event.target.disabled = true
      const data = {
        planning_id: planning.planningVideo.planning_id,
        video_id: planning.video.id,
        stat
      }

      // updating the planning
      updateVodRequest(data)
        .then(({ data }) => {
          emitter.$emit("update-table")
          this.Videos = data
          this.tempVideos = data.map(video => video.id)
          this.isDisabled = false
          Message.success("VOD mis à jour")
          planning.planningVideo.request_status = stat
          event.target.disabled = false
          this.closeLoader()
        })
        .catch(() => {
          this.isDisabled = false
          event.target.disabled = false
          this.closeLoader()
        })
    },
    getAllPlanningVideo() {
      let videos = []
      this.modal.payload.planning.videos.forEach(element => {
        if (element.pivot.request || element.pivot.files) {
          videos.push(element.pivot)
        }
      })
      return videos
    },
    getVideo(planningVideos) {
      let videos = []
      planningVideos.forEach(planningVideo => {
        const video_id = planningVideo.video_id
        // let fetchedVideo = {};
        fetchVideo(video_id).then(video => {
          videos.push({ video, planningVideo })
        })
      })

      return videos
    },
    getFileName(path) {
      return path.substring(path.lastIndexOf("/") + 1)
    },
    downloadFile() {
      const fileName = this.getFileName(
        this.selectedVideo.files[this.currentFile].path
      )
      downloadRequestFile(fileName).then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response]))
        const fileLink = document.createElement("a")

        fileLink.href = fileURL
        fileLink.setAttribute(
          "download",
          this.selectedVideo.files[this.currentFile].name
        )
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },
    setSelectedFile(index) {
      this.currentFile = index
    }
  },
  mounted() {
    this.getPharmacistSupports()
  },
  created() {
    this.videosRequest = this.getAllPlanningVideo().length > 0
    this.videosWithRequest = this.getVideo(this.getAllPlanningVideo())

    if (!this.supports.data.options.length) {
      this.$store.dispatch("getSupports")
    }
    fetchUsers({ role: "pharmacist" }).then(({ data }) => {
      //only get pharmacists
      this.pharmacists = data
    })
    const { planning } = this.modal.payload
    for (const key in this.params) {
      if (planning.hasOwnProperty(key)) {
        if (key === "videos") {
          this.Videos = planning.videos
          this.tempVideos = planning.videos.map(v => v.id)
        } else {
          this.params[key] = planning[key]
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.tox-notifications-container,
.tox-statusbar {
  display: none !important;
}

.table__request {
  margin-top: 30px;
  position: relative;
  &--body {
    border: 1px solid $color-secondary;
    padding: 5px;
    margin-bottom: 20px;
  }
  &--carousel {
    height: 500px;
    margin: 30px 0 0;
  }
  &--item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    .video-player,
    .video-thumbnail {
      box-shadow: unset !important;
    }
  }
  &--return {
    max-width: 300px;
    position: relative;
    right: 0;
    left: calc(100% - 300px);
    margin-bottom: 30px;
  }
}
.download-btn {
  float: right;
  margin: 10px 0;
  z-index: 100;
}
</style>
